// src/components/Journey.js
import React from "react";
import { about } from "../data/about";

export default function Journey() {
  return (
    <div className="px-6 lg:px-40 md:px-12 py-10 flex justify-center @container">
      <div className="w-full max-w-[960px] space-y-10">
        <header className="mb-4">
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#0e1b17]">
            Our Journey
          </h1>
        </header>
        <section>
          <div className="relative pl-6 ">
            <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-[var(--color-mint-200)]" />
            <div className="max-h-120 overflow-y-auto pr-2 px-3">
              <ul className="space-y-5">
                {about.main_events.map((t, idx) => (
                  <li key={idx} className="relative">
                    <div className="absolute -left-0.5 top-1.5 size-3 rounded-full bg-[var(--color-mint-600)]" />
                    <div className="card p-4 border-2 border-green-200 bg-green-50 rounded-xl shadow-sm py-4">
                      <div className="text-xs text-[var(--color-fern-500)]">{t.year}</div>
                      <div className="text-sm font-semibold text-[var(--color-ink)]">{t.title}</div>
                      <div className="text-xs font-semibold text-[var(--color-ink)]/80">{t.funded}</div>
                      <p className="muted mt-1">{t.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <header className="mb-4">
          <h2 className="text-l md:text-3xl font-bold tracking-tight text-[#0e1b17]">
            Key Initiatives
          </h2>
        </header>
        <section>
          <div className="relative pl-6">
            <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-[var(--color-mint-200)]" />
            <div className="max-h-120 overflow-y-auto pr-2 px-3">
              <ul className="space-y-5">
                {about.timeline.slice().reverse().map((t, idx) => (
                  <li key={idx} className="relative">
                    <div className="absolute -left-0.5 top-1.5 size-3 rounded-full bg-[var(--color-mint-600)]" />
                    <div className="card p-4">
                      <div className="text-xs text-[var(--color-fern-500)]">{t.year}</div>
                      <div className="text-sm font-semibold text-[var(--color-ink)]">{t.title}</div>
                      <div className="text-xs font-semibold text-[var(--color-ink)]/80">{t.funded}</div>
                      <p className="muted mt-1">{t.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}